import axiosInstance from "../apis";
import { BASE_URL_V2 } from "../constants";

export type FeedbackItem = {
  appVersion: string;
  area: "Feedback" | "Issue";
  createdAt: string;
  feedback: Array<{ title?: string; text?: string }>;
  image: string | null;
  email: string;
  firstName: string;
  lastName: string;
  id: number;
  reviewed: null | boolean;
  userId: number;
};

type FeedbackResponse = {
  data: {
    subscriptionFeedbacks: Array<FeedbackItem>;
    total: number;
    unreviewed: number;
  };
};

export const requestFeedback = async ({
  page,
  limit,
  area,
  appVersion,
  search,
  sortValue,
  order,
}: {
  page: number;
  limit: number;
  area?: string[];
  appVersion: string[];
  search?: string;
  sortValue?: string | null;
  order?: number | null;
}) => {
  let params: any = {
    page,
    limit,
    appVersion: "",
  };

  if (appVersion?.length) {
    params.appVersion = appVersion?.join("|");
  }
  if (area?.length) {
    params.area = area?.join("|");
  }
  if (search) {
    params.value = search;
  }

  if (sortValue) {
    params.sortValue = sortValue;
  }

  if (order) {
    params.order = order === 1 ? "desc" : "asc";
  }

  return (
    await axiosInstance.get<FeedbackResponse>(`admin/subfeedback`, {
      params,
      baseURL: BASE_URL_V2,
    })
  ).data.data;
};

export const requestViewFeedback = async ({ ids }: { ids: number[] }) => {
  return (
    await axiosInstance.post<FeedbackResponse>(
      `admin/subfeedback`,
      { ids },
      {
        baseURL: BASE_URL_V2,
      }
    )
  ).data.data;
};
